import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWikipediaComponent } from './simple-icons-wikipedia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWikipediaComponent ],
    exports:      [ SimpleIconsWikipediaComponent ],
    bootstrap:    []
})
export class SimpleIconsWikipediaModule {}
